function viewerStateToRouteState(state: string): string {
  return `/${state}`;
}

export default viewerStateToRouteState;
